<template>
  <td scope="row" class="position-sticky table-light cabecera d-flex">
    <i class="fa-solid fa-fw mr-1"></i>
    <span class="align-items-center d-flex">
      <slot></slot>
      <span v-if="descripcion" class="ml-1" :title="descripcion" v-tooltip>
        <i class="fa-solid fa-circle-info"></i>
      </span>
    </span>
  </td>
</template>

<script>
export default {
  name: "cabecera-indicador",
  props: ["descripcion"]
};
</script>